import React from "react";
import { Link, useNavigate } from "react-router-dom";
const divStyle = {
    display: 'flex',
    justifyContent: 'center',
};
function Donate() {
    const navigate = useNavigate();
    navigate("users");
    return (
        <div className="main-content">
            <div className="rs-breadcrumbs breadcrumbs-overlay">
                <div className="breadcrumbs-img">
                    <img src="assets/images/giving.jpg" alt="giving opportunity" />
                </div>
                <div className="breadcrumbs-text white-color">
                    <h1 className="page-title">Why Donate</h1>
                </div>
            </div>


            <section className="intro-section gray-bg pt-30 pb-30 md-pt-64 md-pb-70">
                <div className="container">
                    <div className="row clearfix">
                        <div className="col-lg-12 md-mb-50">
                            <div className="intro-info-tabs">
                                <div className="tab-content tabs-content" id="myTabContent">
                                    <div className="tab-pane tab fade show active" id="prod-overview" role="tabpanel" aria-labelledby="prod-overview-tab">
                                        <div className="content white-bg pt-30">
                                            <div className="course-overview">
                                                <div className="inner-box">
                                                    <h2>Why Donate?</h2>
                                                    <p>Invest in the future, your investment in a hub of innovation, where cutting-edge tech projects come to life, ensures the growth of both students and  IIT Madras. Funds from friends and alumni like you from Canada, empower students committed to leveraging technology for global betterment. Let's extend the reach of #IITMforAll, making quality education and impactful innovation accessible to everyone. </p>
                                                    <div className="btn-part" style={divStyle}>
                                                    <Link className="btn readon2 orange-transparent" to="/givingopportunity" onClick={() => navigate()}>Donate Now</Link>
                                                        {/* <a href="/givingopportunity" className="btn readon2 orange-transparent" target="_blank">Donate Now</a> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Donate;